import {
    FILE_UPLOAD, FILE_VERSIONS, DOCUMENT_COMMENTS, PO_NEW_VERSION_FILE_UPLOAD, FILE_UPLOAD_ADVANCED,
} from '../type'

const initialState = {
    loading: true,
    pos: [],
    results: '',
    resultsupload: '',
}

export default function fileReducer(state = initialState, action) {
    switch (action.type) {

        case FILE_UPLOAD:
            return {
                ...state,
                results: action.payload
            }

        case FILE_VERSIONS:
            return {
                ...state,
                file_versions: action.payload
            }
        case DOCUMENT_COMMENTS:
            return {
                ...state,
                document_comments: action.payload
            }
        case PO_NEW_VERSION_FILE_UPLOAD:
            return {
                ...state,
                po_file_upload: action.payload
            }

        case FILE_UPLOAD_ADVANCED:
            return {
                ...state,
                resultsupload: action.payload
            }

        default: return state
    }

}